import { h } from "preact";

export const FilterIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.62012 4.31006C8.92012 4.86006 8.92012 5.50006 8.67012 6.07006C8.67012 6.08006 8.66012 6.09006 8.66012 6.10006H19.2001V4.31006H8.62012Z"
      fill="currentColor"
    />
    <path
      d="M5.1298 4.31006H0.799805V6.23006H5.18981C5.0098 5.62006 5.0998 4.96006 5.1298 4.31006Z"
      fill="currentColor"
    />
    <path
      d="M19.1904 9.10986H15.1904V10.8999H19.1904V9.10986Z"
      fill="currentColor"
    />
    <path
      d="M7.88957 9.10986H0.80957V10.8999H7.88957V9.10986Z"
      fill="currentColor"
    />
    <path d="M3.44957 13.77H0.80957V15.56H3.44957V13.77Z" fill="currentColor" />
    <path d="M19.1603 13.77H8.28027V15.56H19.1603V13.77Z" fill="currentColor" />
    <path
      d="M7 8.27002C5.35 8.27002 4 6.93002 4 5.27002C4 3.62002 5.34 2.27002 7 2.27002C8.65 2.27002 10 3.61002 10 5.27002C10 6.92002 8.65 8.27002 7 8.27002ZM7 3.63002C6.1 3.63002 5.36 4.37002 5.36 5.27002C5.36 6.17002 6.1 6.91002 7 6.91002C7.9 6.91002 8.64 6.17002 8.64 5.27002C8.64 4.37002 7.91 3.63002 7 3.63002Z"
      fill="currentColor"
    />
    <path
      d="M12.6504 13C11.0004 13 9.65039 11.66 9.65039 10C9.65039 8.35 10.9904 7 12.6504 7C14.3004 7 15.6504 8.34 15.6504 10C15.6504 11.65 14.3004 13 12.6504 13ZM12.6504 8.36C11.7504 8.36 11.0104 9.1 11.0104 10C11.0104 10.9 11.7504 11.64 12.6504 11.64C13.5504 11.64 14.2904 10.9 14.2904 10C14.2904 9.1 13.5604 8.36 12.6504 8.36Z"
      fill="currentColor"
    />
    <path
      d="M5.62012 17.6699C3.97012 17.6699 2.62012 16.3299 2.62012 14.6699C2.62012 13.0199 3.96012 11.6699 5.62012 11.6699C7.27012 11.6699 8.62012 13.0099 8.62012 14.6699C8.62012 16.3199 7.27012 17.6699 5.62012 17.6699ZM5.62012 13.0299C4.72012 13.0299 3.98012 13.7699 3.98012 14.6699C3.98012 15.5699 4.72012 16.3099 5.62012 16.3099C6.52012 16.3099 7.26012 15.5699 7.26012 14.6699C7.26012 13.7699 6.53012 13.0299 5.62012 13.0299Z"
      fill="currentColor"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    class="icon icon--close"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.57062 10.8104L10.8341 9.54713L15.7111 14.4315L14.4477 15.6948L9.57062 10.8104Z"
      fill="currentColor"
    />
    <path
      d="M0.308303 1.5501L1.55756 0.300837L8.00732 6.74855L14.456 0.313345L15.6854 1.54276L1.5432 15.6848L0.313781 14.4554L6.75816 7.9979L0.308303 1.5501Z"
      fill="currentColor"
    />
  </svg>
);

export const RemoveIcon = () => (
  <svg
    class="icon icon--remove"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 5.78261L12.7826 0L14 1.21739L8.21739 7L14 12.7826L12.7826 14L7 8.21739L1.21739 14L0 12.7826L5.78261 7L0 1.21739L1.21739 0L7 5.78261Z"
    />
  </svg>
);

export const CaretIcon = () => (
  <svg
    width="14"
    height="8"
    viewBox="0 0 14 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 1L7 7L1 1"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    class="icon icon--search"
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.81641 10.6738C1.81641 6.14639 5.4866 2.4762 10.014 2.4762C14.5414 2.4762 18.2116 6.14639 18.2116 10.6738C18.2116 15.2012 14.5414 18.8714 10.014 18.8714C5.4866 18.8714 1.81641 15.2012 1.81641 10.6738ZM10.014 1.4762C4.93432 1.4762 0.816406 5.59411 0.816406 10.6738C0.816406 15.7535 4.93432 19.8714 10.014 19.8714C15.0937 19.8714 19.2116 15.7535 19.2116 10.6738C19.2116 5.59411 15.0937 1.4762 10.014 1.4762ZM17.4871 19.0515L23.9253 25.4897L24.6324 24.7825L18.1942 18.3443L17.4871 19.0515Z"
    ></path>
  </svg>
);

export const Minus = () => (
  <svg
    class="icon icon--minus"
    width="12"
    height="2"
    viewBox="0 0 12 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 1.75V0.25L0 0.25L0 1.75L12 1.75Z" fill="black" />
  </svg>
);

export const Plus = () => (
  <svg
    class="icon icon--plus"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4191 6.43506H0.588867V7.77459H13.4191V6.43506Z"
      fill="currentColor"
    />
    <path
      d="M7.8239 0.588379H6.5332V7.00001H7.8239V0.588379Z"
      fill="currentColor"
    />
    <path
      d="M7.8239 9.02295H6.5332V13.4113H7.8239V9.02295Z"
      fill="currentColor"
    />
  </svg>
);

export const SelectedCheck = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="24" height="24" rx="12" fill="white" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2826 13.9537L10.269 13.9676L9.76758 13.447L9.4989 13.1826L9.50601 13.1754L6.99367 10.5668L5 12.6073L10.269 18L12.2913 15.9302L10.2826 13.9537ZM12.0297 12.1656L14.0384 14.1421L20 8.04049L18.0538 6L12.0297 12.1656Z"
      fill="black"
    />
  </svg>
);

export const SelectedCheckSmall = ({ className = "" }) => (
  <svg
    className={className}
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.26899 8.46761L13.0538 0.5L15 2.54049L5.26899 12.5L0 7.10729L1.99367 5.0668L5.26899 8.46761Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowUp = () => (
  <svg
    width="17"
    height="8"
    viewBox="0 0 17 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M-0.000976562 8L8.9537 0L10.1744 1.29914L2.73809 8"
      fill="#1D1D1B"
    />
    <path
      d="M9.14307 2.76188L14.5471 7.99837H16.9989L10.4401 1.57031L9.14307 2.76188Z"
      fill="#1D1D1B"
    />
  </svg>
);

export const ArrowDown = () => (
  <svg
    width="17"
    height="8"
    viewBox="0 0 17 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="#1D1D1B" d="M17,0L8,8L6.8,6.7L14.3,0" />
    <path fill="#1D1D1B" d="M7.9,5.2L2.5,0H0l6.6,6.4L7.9,5.2z" />
  </svg>
);

export const ArrowLeft = () => (
  <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.3 6L6.3 0H8.1L2.7 5.4H15V6.6H2.7L8.1 12H6.3L0.3 6Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowRight = () => (
  <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7 6L8.7 0H6.9L12.3 5.4H0V6.6H12.3L6.9 12H8.7L14.7 6Z"
      fill="currentColor"
    />
  </svg>
);

export const FaqIcon = () => (
  <svg
    class="icon icon--faq"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10Z"
      fill="#646464"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM10.4968 11.765V11.8429H9.10323C9.07742 11.6742 9.05161 11.5055 9.05161 11.3108C9.05161 10.623 9.33548 9.98702 10.071 9.42896L10.6903 8.96175C11.0774 8.67623 11.2452 8.32582 11.2452 7.93647C11.2452 7.33948 10.8194 6.76844 9.95484 6.76844C9.03871 6.76844 8.63871 7.5082 8.63871 8.23497C8.63871 8.39071 8.65161 8.53347 8.69032 8.65027L7.06452 8.58538C7.0129 8.40369 7 8.19604 7 8.00137C7 6.59973 8.04516 5.25 9.95484 5.25C11.9548 5.25 13 6.52186 13 7.83265C13 8.85792 12.4839 9.5847 11.7226 10.1298L11.1935 10.5061C10.7419 10.8306 10.4968 11.2329 10.4968 11.765ZM9.82581 14.75C9.25806 14.75 8.80645 14.2958 8.80645 13.7247C8.80645 13.1537 9.25806 12.6865 9.82581 12.6865C10.3935 12.6865 10.8581 13.1537 10.8581 13.7247C10.8581 14.2958 10.3935 14.75 9.82581 14.75Z"
      fill="#646464"
    />
  </svg>
);

export const WarrantyIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.96094 22.0391C4.95469 21.0328 5.62188 18.9219 5.10781 17.6859C4.59375 16.45 2.625 15.3672 2.625 14C2.625 12.6328 4.57188 11.5938 5.10781 10.3141C5.64375 9.03438 4.95469 6.96719 5.96094 5.96094C6.96719 4.95469 9.07813 5.62188 10.3141 5.10781C11.55 4.59375 12.6328 2.625 14 2.625C15.3672 2.625 16.4062 4.57188 17.6859 5.10781C18.9656 5.64375 21.0328 4.95469 22.0391 5.96094C23.0453 6.96719 22.3781 9.07813 22.8922 10.3141C23.4063 11.55 25.375 12.6328 25.375 14C25.375 15.3672 23.4281 16.4062 22.8922 17.6859C22.3563 18.9656 23.0453 21.0328 22.0391 22.0391C21.0328 23.0453 18.9219 22.3781 17.6859 22.8922C16.45 23.4063 15.3672 25.375 14 25.375C12.6328 25.375 11.5938 23.4281 10.3141 22.8922C9.03438 22.3563 6.96719 23.0453 5.96094 22.0391Z"
      stroke="black"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.8125 11.375L12.3922 17.5L9.1875 14.4375"
      stroke="black"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CaretDown = () => (
  <svg
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 1.47152L1.48211 0.109375L7.01538 5.2986L12.5407 0.109375L14 1.47152L7.01538 8.10938L0 1.47152Z"
      fill="black"
    />
  </svg>
);

export const Spinner = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 612 612"
    className="icon--spinner"
    style="enable-background:new 0 0 612 612;"
  >
    <circle
      style="opacity:0.1"
      fill="#000000"
      class="st0"
      cx="304.8"
      cy="313.5"
      r="256.4"
    />
    <path
      fill="#FEDD2F"
      d="M247.8,99.8c0,0,1.1-2.6,26.7-6.4c21.1-3.4,28.2-3,31.2-2.9c4.4,0.1,6.9,0.1,26.2,2.3s30.6,5.7,30.6,5.7
    l0.6,79.6l-52.9,89.2l-5.1,3.2l-5.7-3.2l-52.9-88.5L247.8,99.8z"
    />
  </svg>
);

export const Play = () => (
  <svg
    width="8"
    height="9"
    viewBox="0 0 8 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="icon--play"
  >
    <path
      d="M7.5 4.5L0.75 8.39711L0.75 0.602885L7.5 4.5Z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowUpRightBox = () => (
  <svg
    class="icon--arrow-up-right-box"
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7099 12.8691H3.16992V4.11914H9.02992L10.2799 2.86914H1.91992V14.1191H13.9599V6.88914L12.7099 8.13914V12.8691Z"
      fill="currentColor"
    />
    <path
      d="M9.88994 0L8.82994 1.07H15.2199L14.7299 1.56L13.6799 2.61L7.93994 8.35L8.64994 9.06L14.2399 3.47L15.2899 2.42L15.9299 1.78V8.17L16.9999 7.11V0H9.88994Z"
      fill="currentColor"
    />
  </svg>
);
